import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

/** Lib Imports */
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Password } from "primereact/password";
import { InputText } from "primereact/inputtext";
import MolForm, { Field } from "@moltech/molui/molform";
import LoginImage from "./loginImage.js"

/** Utilities */
import { authentication } from "../../app/slice/authSlice";
import {
  createCookie,
  getCookie,
  isCookieExist,
  removeCookie,
} from "../../utils/cookies/CookieHandler";

import { useLoginMutation } from "../../app/services/authApi.js";
import { useDispatch } from "react-redux";
import "./Login.scss";

const initialValue = {
  email: "",
  password: "",
  rememberMe: false,
};

const Login = () => {
  const loginFormRef = useRef();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formValues, setFormValues] = useState(initialValue);
  const [rememberMe, setRememberMe] = useState(formValues.rememberMe);

  const [
    login,
    { isLoading: isLoginLoading, isSuccess: isLoginSuccess, data: loginData },
  ] = useLoginMutation();

  useEffect(() => {
    if (isCookieExist("rememberMe")) {
      const rememberMeCookie = getCookie("rememberMe");
      const cookieData = {
        email: rememberMeCookie.email,
        password: rememberMeCookie.password,
        rememberMe: true,
      };
      setFormValues({ ...cookieData });
    } else {
      resetForm();
    }
  }, []);

  useEffect(() => {
    if (isLoginSuccess && loginData) {
      if (loginData.isAuthenticated === true) {
        dispatch(authentication(loginData));
        if (rememberMe) {
          const formData = loginFormRef.current?.getData();
          const cookieValue = {
            email: formData.email,
            password: formData.password,
          };
          const cookieData = {
            cookieName: "rememberMe",
            cookieValue: cookieValue,
            path: "/",
            expirationTime: 60,
          };
          createCookie(cookieData);
        } else if (isCookieExist("rememberMe")) {
          removeCookie("rememberMe");
        }
        navigate("/");
      } else if (loginData.isAuthenticated === false && loginData.message) {
        alert(loginData.message);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoginSuccess, loginData]);

  const resetForm = () => {
    setFormValues(initialValue);
  };

  const handleFormSubmit = () => {
    const formData = loginFormRef.current?.getData();
    if (formData) {
      const formReq = {
        email: formData.email,
        password: formData.password,
      };
      setRememberMe(formData.rememberMe);
      login(formReq);
    }
  };

  const handleSaveClick = () => {
    if (loginFormRef.current) {
      loginFormRef.current.submit();
    }
  };

  return (
    <div className="login-page">

      <div className="login-left">
        <div className="welcome-box">
          <div className="login-img">
            <LoginImage />
          </div>
          <p>
            A lightweight HR management system that helps track employees,
            attendance, and leave requests in one place. Make workforce
            management easier and more efficient!
          </p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-card">
          <h2>Moltech R</h2>
          <p className="sub-text">
            Log in to your account to continue.
          </p>

          <MolForm
            ref={loginFormRef}
            onSubmit={handleFormSubmit}
            initialValues={formValues}
          >
            <div className="form-field">
              <Field
                component={InputText}
                name="email"
                label="Email Address"
                placeholder="Email Address"
                validation="required"
              />
            </div>
            <div className="form-field">
              <Field
                component={Password}
                feedback={false}
                toggleMask
                name="password"
                label="Password"
                placeholder="Password"
                validation="password"
              />
            </div>
            <div className="form-check">
              <Field
                className="checkbox-field"
                component={Checkbox}
                name="rememberMe"
                label="Remember Me"
              />
            </div>
          </MolForm>

          <Button
            label="Login Now"
            loading={isLoginLoading}
            className="p-button-md btn theme-btn btn-primary w-100 py-2 login-btn"
            onClick={handleSaveClick}
          />
        </div>
      </div>
      
    </div>
  );
};

export default Login;
